export var AwardAnnouncementStatus;
(function (AwardAnnouncementStatus) {
    AwardAnnouncementStatus["None"] = "NONE";
    AwardAnnouncementStatus["Login"] = "LOGIN";
    AwardAnnouncementStatus["Map"] = "MAP";
    AwardAnnouncementStatus["Card"] = "CARD";
})(AwardAnnouncementStatus || (AwardAnnouncementStatus = {}));
//# sourceMappingURL=AwardAnnouncement.js.map